import React, {
  CSSProperties,
  FC,
  memo,
  ReactNode,
  useId,
  useMemo,
} from "react";
import { ITooltip, Tooltip as ReactTooltip } from "react-tooltip";
import styled from "styled-components";

interface TooltipProps extends ITooltip {
  children: ReactNode;
  body: ReactNode | null;
  $zIndex?: number;
}

export const TooltipTrigger = styled.div`
  display: inline-flex;
  vertical-align: middle;
`;

const Tooltip: FC<TooltipProps> = ({
  children,
  body,
  place = "bottom",
  $zIndex,
  style,
  ...otherProps
}) => {
  // Stable across renders, so an open tooltip survives its host re-rendering.
  const tooltipId = useId();

  const tooltipStyle: CSSProperties | undefined = useMemo(() => {
    if ($zIndex) {
      return { ...style, zIndex: $zIndex };
    }
    return style;
  }, [$zIndex, style]);

  return (
    <>
      <TooltipTrigger data-tooltip-id={tooltipId}>
        {children}
      </TooltipTrigger>
      <ReactTooltip id={tooltipId} place={place} style={tooltipStyle} {...otherProps}>
        {body}
      </ReactTooltip>
    </>
  );
};

export default memo(Tooltip);
